var SnackbarVariant = /* @__PURE__ */ ((SnackbarVariant2) => {
  SnackbarVariant2["Compact"] = "compact";
  SnackbarVariant2["Multiline"] = "multiline";
  return SnackbarVariant2;
})(SnackbarVariant || {});
export {
  SnackbarVariant
};
